var _g, _g2, _path, _path2, _g3, _path3, _path4, _g4, _rect, _rect2, _g5, _path5, _rect3, _path6, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot17(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 78C35.046 89.6966 18.0959 84.6663 14.6313 96.009C11.1668 107.352 22.6565 116 32.1552 116",
    stroke: "#2A3544",
    strokeWidth: 6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 121C158.394 124.486 170.102 113.406 166 104.5C161.898 95.5937 150 97.8056 150 85.1951",
    stroke: "#2A3544",
    strokeWidth: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138 72C136.895 72 136 72.8954 136 74V88C136 89.1046 136.895 90 138 90H157C158.105 90 159 89.1046 159 88V74C159 72.8954 158.105 72 157 72H138ZM21 103C21 101.895 21.8954 101 23 101H35C36.1046 101 37 101.895 37 103V121C37 122.105 36.1046 123 35 123H23C21.8954 123 21 122.105 21 121V103ZM136 110C136 108.895 136.895 108 138 108H157C158.105 108 159 108.895 159 110V128C159 129.105 158.105 130 157 130H138C136.895 130 136 129.105 136 128V110Z",
    fill: "#273951"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_41",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 72,
    width: 138,
    height: 58
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138 72C136.895 72 136 72.8954 136 74V88C136 89.1046 136.895 90 138 90H157C158.105 90 159 89.1046 159 88V74C159 72.8954 158.105 72 157 72H138ZM21 103C21 101.895 21.8954 101 23 101H35C36.1046 101 37 101.895 37 103V121C37 122.105 36.1046 123 35 123H23C21.8954 123 21 122.105 21 121V103ZM136 110C136 108.895 136.895 108 138 108H157C158.105 108 159 108.895 159 110V128C159 129.105 158.105 130 157 130H138C136.895 130 136 129.105 136 128V110Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_41)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 66,
    width: 180,
    height: 76,
    fill: "#EF9A9A"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89 0C80.1634 0 73 7.16344 73 16V32C73 36.4183 76.5817 40 81 40H64C63.4477 40 63 40.4477 63 41V51C63 51.5523 63.4477 52 64 52H118C118.552 52 119 51.5523 119 51V41C119 40.4477 118.552 40 118 40H101C105.418 40 109 36.4183 109 32V16C109 7.16344 101.837 0 93 0H89Z",
    fill: "#59C4FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_41",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 0,
    width: 56,
    height: 52
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89 0C80.1634 0 73 7.16344 73 16V32C73 36.4183 76.5817 40 81 40H64C63.4477 40 63 40.4477 63 41V51C63 51.5523 63.4477 52 64 52H118C118.552 52 119 51.5523 119 51V41C119 40.4477 118.552 40 118 40H101C105.418 40 109 36.4183 109 32V16C109 7.16344 101.837 0 93 0H89Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_41)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    width: 100,
    height: 52,
    fill: "#D50000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: -3,
    width: 60,
    height: 43,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 3.5C94.9315 3.5 99.366 5.62814 102.435 9.01616",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8284 26L81.8284 17L79 19.8284L89 29.8284V40H93V29.9706L103.142 19.8284L100.314 17L91.3137 26H90.8284Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 44,
    width: 130,
    height: 120,
    rx: 18,
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_41",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 44,
    width: 130,
    height: 120,
    rx: 18,
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_41)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 42,
    width: 134,
    height: 124,
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8804 165.092C19.2413 134.402 27.938 160.534 48.8656 155.124C58.1114 152.734 50.641 142.296 57.5369 137.772C63.3618 133.95 71.2997 137.029 77.9721 134.558C87.6014 130.991 87.4748 123.735 96.4469 122.651C104.932 121.625 113.82 125.005 122.378 123.735C138.528 121.339 131.906 89.7111 144.017 84.1252C156.128 78.5392 176.068 88.1858 178.678 104C181.222 119.417 164.22 176.78 164.22 176.78H14.8804",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9268 165C97.6044 165 101.527 150.25 120.065 143.493C138.603 136.735 154.846 154.214 161.078 137.233C167.31 120.253 167.276 173.181 167.276 173.181H59.9268L59.9268 165Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 47.8673C33.7332 46.7465 29.9619 59.8061 34.5974 59.8061C36.4464 59.8061 38.6253 51.3489 41.9832 51.3489C44.438 51.3489 43.9753 56.8425 49.305 56.2617C54.3077 55.7166 53.3754 52.2687 55.9027 52.2687C61.3454 52.2687 59.2873 72.4636 63.6441 72.4636C68.0009 72.4636 69.3737 57.668 71.2914 51.8164C73.7181 44.4119 88.2635 40.2616 77.8923 37.3201H21.7133",
    fill: "black",
    fillOpacity: 0.4
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0493 132.442C78.8055 131.364 79.4812 130.293 80.5585 130.049C81.6358 129.806 82.7068 130.481 82.9507 131.559C83.72 134.958 86.4017 137 90 137C93.5984 137 96.28 134.958 97.0493 131.559C97.2932 130.481 98.3642 129.806 99.4415 130.049C100.519 130.293 101.195 131.364 100.951 132.442C99.76 137.702 95.4299 141 90 141C84.5701 141 80.2401 137.702 79.0493 132.442Z",
    fill: "black",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 48,
    transform: "translate(38 76)",
    fill: "#9F9F9F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 120C76.3707 120 84.8978 112.107 85.9012 102H127.416C128.188 103.766 129.95 105 132 105C134.761 105 137 102.761 137 100C137 97.2386 134.761 95 132 95C129.95 95 128.188 96.2341 127.416 98H85.9012C84.8978 87.8934 76.3707 80 66 80C54.9543 80 46 88.9543 46 100C46 111.046 54.9543 120 66 120Z",
    fill: "black",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 100,
    r: 2,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 100,
    r: 16,
    fill: "black",
    fillOpacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 92,
    r: 3,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot17);
export default __webpack_public_path__ + "static/media/bot-17.0497dd91fd338298f78e76ea9ff1fb8c.svg";
export { ForwardRef as ReactComponent };